import CloseIcon20 from "assets/svgs/CloseIcon20";
import SearchIcon from "assets/svgs/SearchIcon";
import { CloseIcon } from "../FiltersSidebar/styles";
import { Container } from "./styles";

const SearchBar = ({
	searchQuery,
	setSearchQuery,
	placeholder = "Search",
	showCloseIcon = false,
}) => (
	<Container>
		<SearchIcon fill="#8C8594" />
		<input
			placeholder={placeholder}
			onChange={(event) => setSearchQuery(event.target.value)}
			value={searchQuery}
		/>
		{showCloseIcon && searchQuery?.length ? (
			<CloseIcon onClick={() => setSearchQuery("")}>
				<CloseIcon20 fill="#8c8594" />
			</CloseIcon>
		) : (
			""
		)}
	</Container>
);

export default SearchBar;
